export const environment = {
  production: false,
  settingsServiceBasePath: 'https://api.dev.smartobjx.com/settings-demo',
  publicBasePath: 'https://api.dev.smartobjx.com/public',
  ruleServiceBasePath: 'https://api.dev.smartobjx.com/rules-demo',
  structureServiceBasePath: 'https://api.dev.smartobjx.com/structures-demo',
  SubcriptionService:'https://so-preproduction-subscriptionmanagement-east.azurewebsites.net/',
  logins: [
    { name: "SaaS publisher", oid: "45ef2936-160e-47dc-bd17-3dc0060acec9" },
    { name: "Client", oid: "25ef2936-160e-47dc-bd17-3dc0060acec9" },
    { name: "Customer", oid: "05ef2936-160e-47dc-bd17-3dc0060acec9" }
  ]
};
